import { EmptyPageStore } from './empty-page.store';
import { Component, inject } from '@angular/core';

@Component({
    selector: 'app-empty-page',
    templateUrl: './empty-page.component.html',
    styleUrl: './empty-page.component.scss',
    providers: [EmptyPageStore],
    imports: []
})
export class EmptyPageComponent {

    public readonly store = inject(EmptyPageStore);

}
